import DraftTextEditor from './DraftTextEditor';

export default DraftTextEditor;
